$(function(){ 
	console.log('Ganpati Bappa Morya!!'); 
    let winWT = $(window).innerWidth();
    let winHT = $(window).innerHeight(); 
    let previousScroll = 0;
    const header = $("header");
    let headerHT = $("header").innerHeight();
    let lenis;
    let circleLeftRotation = 0;
    let lastScrollTop = $(window).scrollTop();

    function reconnectLenis(){
        lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        infinite: false
        });
        lenis.on("scroll", ScrollTrigger.update);
        gsap.ticker.add((time) => {
        
        lenis.raf(time * 1000); 
        });
        gsap.ticker.lagSmoothing(0);
    }
    reconnectLenis();
    
    AOS.init({
      easing: 'ease-out-in',
      duration: 1200,
      once: true,
      /* disable: function () {
        var maxWidth = 767;
        return window.innerWidth < maxWidth;
      } */
    });

    gsap.registerPlugin(ScrollTrigger);

    function setHeaderOnScroll(){
      winWT = $(window).innerWidth();
      if(winWT >= 1024){
        if ($(this).scrollTop() > 120) {
          $('header').addClass('sticky');
        } else {
          $('header').removeClass('sticky');
        }
      }
    }
    setHeaderOnScroll(); 

    $(window).on("scroll", function () {
      setHeaderOnScroll(); 
    });

    $(window).on("resize", function () {
      setHeaderOnScroll();
      parallaxBanner();
    });

   /*  $('.scroll-indicator').click(function() {
      $('html, body').animate({
        scrollTop: $('section').next().offset().top
      }, 1000);
    }); */

    function callCounters(){ 
      const counters = document.querySelectorAll(".counter");
      counters.forEach((counter) => {
        counter.innerText = "0";
        const updateCounter = () => {
          const target = +counter.getAttribute("data-target");
          const count = +counter.innerText.replace(/,/g, '');
          const increment = target / 200;
          if (count < target) {
            const nextValue = Math.ceil(count + increment);
            counter.innerText = Number.isInteger(nextValue)
              ? nextValue.toLocaleString()
              : nextValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            setTimeout(updateCounter, 7);
          } else counter.innerText = Number.isInteger(target)
              ? target.toLocaleString()
              : target.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };
        updateCounter();
      });
    }
 
    gsap.to(".circle-left", {
      scrollTrigger: {
        trigger: ".strong-foundation",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        // markers: true, // Uncomment for debugging
      },
      rotation: 60, // Adjust as needed for desired rotation
      ease: Power1.easeIn
    });
    
    gsap.to(".circle-right", {
      scrollTrigger: {
        trigger: ".strong-foundation",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        //markers: true, // Uncomment for debugging
      },
      rotation: -60, // Opposite direction
      ease: Power1.easeInOut
    });

    /* gsap.to(".circle-left", {
      scrollTrigger: {
        trigger: ".download-center",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        // markers: true, // Uncomment for debugging
      },
      rotation: 60, // Adjust as needed for desired rotation
      ease: Power1.easeIn
    }); */
    

    /* gsap.to(".performance-highlights figure img", {
      scrollTrigger: {
        trigger: ".performance-highlights",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        markers: true, // Uncomment for debugging
      },
      top: -50, // Move up by 50px as you scroll
      opacity: 1, // Ensure fully visible at end
      ease: "power1.inOut"
    });
 */
  
  function parallaxBanner(){ 
    gsap.utils.toArray(".parallax-banner").forEach(function(container) {
      let image = container.querySelector("img");
    
      let tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            scrub: true,
            pin: false,
          },
        }); 
        tl.from(image, {
          yPercent: -30,
          ease: "none",
        }).to(image, {
          yPercent: 30,
          ease: "none",
        }); 
    });
  }
  parallaxBanner();

  /****************************************************************/
  /****************************************************************/

  let keyPerformanceArr = $('.key-ph-panel').find('li');
  setTimeout(function(){
    $(keyPerformanceArr[0]).trigger("click");
  }, 1000);

  keyPerformanceArr.each(function(){
    $(this).on('click', function(){
      let currPerformance = $(this).attr('keyPH');
      let currHighlightDet = '#det-' + currPerformance; 

      // Update progress line height with animation
      if(winWT > 1023){
        let liHeight = $(this).outerHeight();
        let progressHeight = $(this).position().top + (liHeight / 2);
        $('.progress-line').animate({
          'height': progressHeight + 'px'
        }, 300);
        
        // Update circle position
        $('.circle').animate({
          'top': progressHeight + 'px'
        }, 300);
      }else{
        let liWidth = $(this).innerWidth();
        let progressWidth = $(this).position().left + (liWidth / 2);
        $('.progress-line').animate({
          'width': progressWidth + 'px'
        }, 300);
        
        // Update circle position
        $('.circle').animate({
          'left': progressWidth + 'px'
        }, 300);
      }
      $('.per-det-con').css({display:'none'});
      $(currHighlightDet).fadeIn();
      keyPerformanceArr.removeClass('active-ph');
      $(this).addClass('active-ph'); 
    }); 
  });

  /* Case Study Slider */
  var swiperCaseStudySlider = new Swiper(".cs-slider", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,   
    autoplay: {
      delay: 3000,
     // disableOnInteraction: false
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    },
    speed: 400, 
    breakpoints: {
        1024: {
            slidesPerView: 3, 
        },
        768: {
            slidesPerView: 2, 
        },
        320: {
          spaceBetween: 0,
            slidesPerView: 1, 
        }
    } 
  });  

  var swiperAwardsSlider = new Swiper(".award-blurb-con", {
    slidesPerView: 3,
    spaceBetween: 25,
    loop: true,   
    autoplay: {
      delay: 3000,
     // disableOnInteraction: false
    },
    speed: 400, 
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    },
    breakpoints: { 
        767: {
            slidesPerView: 3, 
        }, 
       320: {
            slidesPerView: 1, 
            spaceBetween: 10,
        }
    } 
  }); 

  let plantDetArr = $('.plant-det'); 
  let plantNameArr = $('.our-plant .sect-tl').find('h2'); 
  let swiperPlantsSlider = new Swiper(".plants-slider", {
    slidesPerView: 3,
    spaceBetween: 0, 
    centeredSlides: true,
    preventClicks:true,
    loop:true,  
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    },
    on:{
      init:function(){
        plantDetArr.hide();
        plantNameArr.hide();
        $(plantDetArr[this.realIndex]).css({display:'flex'});
        $(plantNameArr[this.realIndex]).css({display:'block'});
      },
      slideChange:function(){
        plantDetArr.hide();
        plantNameArr.hide();
        $(plantDetArr[this.realIndex]).css({display:'flex'});
        $(plantNameArr[this.realIndex]).css({display:'block'});
      }
    },
    breakpoints: { 
        768: {
            slidesPerView: 3, 
        }, 
       320: {
            slidesPerView: 1, 
            spaceBetween: 0, 
        }
    } 
  });

  window.swiperBODSlider = new Swiper(".bod-hld", { 
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true, 
    on:{
      init: function() {
        const activeIndex = this.activeIndex;
        resetBodSectAnim(activeIndex);
        //animateBodSectAnim(activeIndex);
      },
      slideChange: function() {
        const activeIndex = this.activeIndex;
        resetBodSectAnim(activeIndex);
      },
      slideChangeTransitionStart: function() {
        const activeIndex = this.activeIndex;
        resetBodSectAnim(activeIndex);
      },
      slideChangeTransitionEnd: function() {
        const activeIndex = this.activeIndex;
        animateBodSectAnim(activeIndex);
      },
      resize: function () {
        const activeIndex = this.activeIndex;
        resetBodSectAnim(activeIndex);
        animateBodSectAnim(activeIndex);
      }
    }
  }); 
  function resetBodSectAnim(slideIndex){
    let currentSlide = $('.bod-hld .swiper-slide').eq(slideIndex);
    let currentH3 = currentSlide.find('.sect-tl h3');
    let currentSpWords = currentSlide.find('.sect-tl h2 .split-word');
    let currentSpPara = currentSlide.find('.lineChild');
    let currentBtnPanel = currentSlide.find('.bod-btns');
    let currentFigure= currentSlide.find('figure');
    let currentDesignation= currentSlide.find('.name-des');
 
    gsap.set(currentH3, { opacity:0, y : 40 } )
    gsap.set(currentSpWords, {  opacity:0, y : 40 } )
    gsap.set(currentSpPara, {  opacity:0, y : 40 } )
    gsap.set(currentBtnPanel, {  opacity:0, y : 40 } )
    gsap.set(currentFigure, {  opacity:0, scale : 0.6 } )
    gsap.set(currentDesignation, {  opacity:0, x : 60 } )
  }
  function animateBodSectAnim(slideIndex){
    let currentSlide = $('.bod-hld .swiper-slide').eq(slideIndex);
    let currentH3 = currentSlide.find('.sect-tl h3');
    let currentSpWords = currentSlide.find('.sect-tl h2 .split-word');
    let currentSpPara = currentSlide.find('.lineChild');
    let currentBtnPanel = currentSlide.find('.bod-btns');
    let currentFigure= currentSlide.find('figure');
    let currentDesignation= currentSlide.find('.name-des');
    
    let tlBODSlideAnim = gsap.timeline();
    tlBODSlideAnim.to(currentFigure, { duration: 0.4, opacity: 1, scale: 1, }) 
                  .to(currentDesignation, { duration: 0.6, opacity: 1, x: 0, stagger: 0.1, }, '-=0.2') 
                  .to(currentH3, { duration:0.6, opacity:1, y : 0,  ease: "power2.out"} , '-=0.6' )
                  .to(currentSpWords, { duration:0.4, opacity:1, y : 0, stagger:0.1,  ease: "power2.out"}, '-=0.4' )
                  .to(currentSpPara, { duration: 0.4, opacity: 1, y: 0, stagger: 0.1, }, '-=0.4') 
                  .to(currentBtnPanel, { duration: 0.7, opacity: 1, y: 0,  }, '-=0.2')  
  }           

  window.goToSlide = function(index) { 
    swiperBODSlider.slideTo(index); 
  }



  gsap.to(".bod-messages .circle-right", {
    scrollTrigger: {
      trigger: ".bod-messages",
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      //markers: true, // Uncomment for debugging
    },
    rotation: -100, // Adjust as needed for desired rotation
    ease: Power1.easeIn
  });

  // Initialize matrix sliders for all tabs
  let matrixSliders = [];
  
  function initMatrixSliders() {
    // Destroy existing sliders if any
    matrixSliders.forEach(slider => {
      if (slider && slider.destroy) {
        slider.destroy(true, true);
      }
    });
    matrixSliders = [];
    
    // Initialize sliders for each tab
    $('.matrix-slider').each(function(index) {
      let $slider = $(this);
      let sliderId = 'matrix-slider-' + index;
      $slider.attr('id', sliderId);
      
      let swiper = new Swiper("#" + sliderId, {
        slidesPerView: 1, 
        /* effect: 'fade',
        fadeEffect: {
          crossFade: true,
        }, */
        loop: false,   
        speed: 400, 
        navigation: {
          nextEl: "#" + sliderId + " .swiper-button-next",
          prevEl: "#" + sliderId + " .swiper-button-prev",
          clickable: true,
        },
        on:{
          init: function() {
            const activeIndex = this.activeIndex;
            resetMatrixSectAnim(activeIndex, index);
            animateMatrixSectAnim(activeIndex, index);
          },
          slideChange: function() {
            const activeIndex = this.activeIndex;
            resetMatrixSectAnim(activeIndex, index);
          },
          slideChangeTransitionStart: function() {
            const activeIndex = this.activeIndex;
            resetMatrixSectAnim(activeIndex, index);
          },
          slideChangeTransitionEnd: function() {
            const activeIndex = this.activeIndex;
            animateMatrixSectAnim(activeIndex, index);
          },
          resize: function () {
            const activeIndex = this.activeIndex;
            resetMatrixSectAnim(activeIndex, index);
            animateMatrixSectAnim(activeIndex, index);
          }
        }
      });
      
      matrixSliders.push(swiper);
    });
  }
  
  // Initialize matrix sliders
  initMatrixSliders();
  
  // Handle tab switching for matrix sliders
  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
    let targetTab = $(e.target).attr('href');
    let tabIndex = $(targetTab).index();
    
    // Update the active slider
    if (matrixSliders[tabIndex]) {
      matrixSliders[tabIndex].update();
      matrixSliders[tabIndex].updateSlides();
    }
  });

  function resetMatrixSectAnim(slideIndex, tabIndex){  
    let currentSlide = $('#matrix-slider-' + tabIndex + ' .swiper-slide').eq(slideIndex); 
     let matrixInfo = currentSlide.find('.matrix-info');
     let matrixHighlights = currentSlide.find('.matrix-highlights');
     gsap.set(matrixInfo, { opacity:0, x : -30 } )
     gsap.set(matrixHighlights, { opacity:0, x : 30 } )
  } 
  function animateMatrixSectAnim(slideIndex, tabIndex){  
     let currentSlide = $('#matrix-slider-' + tabIndex + ' .swiper-slide').eq(slideIndex);
     let matrixInfo = currentSlide.find('.matrix-info');
     let matrixHighlights = currentSlide.find('.matrix-highlights');
     let tlMatrixSlideAnim = gsap.timeline();
    tlMatrixSlideAnim.to(matrixInfo, { duration: 0.4, opacity: 1, x: 0, }) 
                  .to(matrixHighlights, { duration: 0.6, opacity: 1, x: 0 }, '-=0.2')  
  } 


  if($('.bar-indicator-slider-1').length > 0 ){
    var FinancialIndicatorsSwiper = new Swiper(".bar-indicator-slider-1", { 
      pagination: {
        el: '.bar-indicator-slider-1 .swiper-pagination',
        clickable: true, 
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        }, 
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
      },
    });
  }

  
  
   if($('.bar-indicator-slider-2').length > 0 ){
    var FinancialIndicatorsSwiper = new Swiper(".bar-indicator-slider-2", { 
      pagination: {
        el: '.bar-indicator-slider-2 .swiper-pagination',
        clickable: true, 
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
        1680: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 3,
        },
      },
    });
  }

  wow = new WOW({
      mobile: false,
      offset: 0,
  });
  wow.init();

  $('.modal').on('show.bs.modal', function () {
    lenis.destroy();
    $('body').css('overflow', 'hidden');
  });
  
  $('.modal').on('hidden.bs.modal', function () {
    lenis.start();
    $('body').css('overflow', '');
    reconnectLenis();
  });

  /*************************************************************************************************************/
  /*************************************************************************************************************/
  /*************************************************************************************************************/
  /*************************************************************************************************************/

  /* Anim */ 
  let bannerVideo = $('#banner').find('video')[0]; 
  gsap.set('header', { opacity:1, y:-100});
  let splashScreenAim = () => {
    let tl_Banner = gsap.timeline();
    tl_Banner.to('.logo-chakra', { duration:1.5, scale:2, opacity:0},'b-anim')
           .to('.logo-s', { duration:1.5, scale:2, opacity:0},'b-anim')
           .to('.splash-screen', { duration:1.5, opacity:0, onComplete: function(){  
              bannerVideo.play();
           }},'b-anim-=0.5')
           .to('header', { duration:1.5, opacity:1, y:0, },'b-anim-=0.2')
  }

  //gsap.registerPlugin(SplitText);
  
  function pageAnimation() {
    let splitTitle = $('.sp-txt'); 
    let splitIntroPara = $('.sp-para');  
  
    function animateSectionOnScroll(selector, timelineCallback) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: selector,
          start: "top 60%",
          end: "bottom top",
          toggleActions: "play none none reverse",
          scrub: false,
          //markers: true,
        }
      });
      timelineCallback(tl, selector);
    }
  
    // Ensure DOM + fonts loaded
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        requestAnimationFrame(() => {
          if (!splitTitle.length || !splitIntroPara.length) return;
  
          // Split text
          const splitTl = new SplitText(splitTitle, {
            type: "words",
            wordsClass: "split-word"
          });  
          const splitParaChild = new SplitText(splitIntroPara, {
            type: "lines", 
            linesClass: "lineChild"
          });
          const splitPara = new SplitText(splitIntroPara, {
            type: "lines", 
            linesClass: "lineParent"
          });  

           // SEPARATE animation for .read-more
          function readMoreBtnAnim(selector){
            gsap.from(selector + " .read-more", {
              scrollTrigger: {
                trigger: selector + " .read-more",
                start: "top 80%",
                //toggleActions: "play none none reverse",
                //markers: true
              },
              duration: 0.3,
              opacity: 0,
              y: 50,
              ease: "power2.out"
            });
          }

          // Main animation timeline 
          animateSectionOnScroll('.strong-foundation', function(tl, selector) { 
            tl.from(selector + " .circle-left", { opacity: 0, x: -180, duration: 0.6, } , 'label')
              .from(selector + " .circle-right", { opacity: 0, x: 180, duration: 0.6, } , 'label')
              .from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, } , 'label-=0.3') 
              .from(selector + " .lineChild", { duration: 0.4, opacity: 0, yPercent: 80, stagger: 0.1, }, '-=0.3') 
              .from(selector + " .btn-hld", { duration: 0.4, opacity: 0, yPercent: 80 }, '-=0.2') 
          });
          animateSectionOnScroll('.performance-highlights', function(tl, selector) {
            tl.from(selector + " .sect-tl h3", { opacity: 0, y: 40, duration: 0.4, ease: 'power1.in' } ) 
              .from(selector + " .sp-txt .split-word", { opacity: 0, y:40, duration: 0.6, stagger: 0.1, ease: 'power1.out'}, '-=0.2') 
              .from(selector + " .key-ph-panel", { opacity: 0, y:60, duration: 0.6, ease: 'power1.out' }, '-=0.4')  
              .from(selector + " .btn-hld", { opacity: 0, y:60, duration: 0.6, ease: 'power1.out' }, '-=0.4')  
              .from(selector + " .per-det-con h4", { opacity: 0, y:40, duration: 0.6, ease: 'power1.out'}, '-=0.7') 
              .from(selector + " .svg-con", { opacity: 0, duration: 0.6, ease: 'power1.out'}, '-=0.6') 
              .from(selector + " .counter-con", { opacity: 0, y:40, duration: 0.6, stagger:0.1, ease: 'power1.out'}, '-=0.3') 
              
          });

          animateSectionOnScroll('.about-cement', function(tl, selector) {
            tl.from(selector + " .sect-tl h3", { opacity: 0, y: 40, duration: 0.4, ease: 'power1.in' }) 
              .from(selector + " .sp-txt .split-word", { opacity: 0, y:40, duration: 0.6, stagger: 0.1, ease: 'power1.out'}, '-=0.2')  
              .from(selector + " .lineChild", { duration: 0.8, opacity: 0, yPercent: 60, stagger: 0.1 }, '-=0.4') 
              .from(selector + " .btn-hld", { opacity: 0, y:60, duration: 0.6, ease: 'power1.out' }, '-=0.2')  
              .from(selector + " .key-figures-hld", { opacity: 0, y:60, duration: 0.6, ease: 'power1.out', onComplete:function(){
                callCounters();
              }}, '-=0.2') 
          });

          animateSectionOnScroll('.our-plant', function(tl, selector) {
            tl.from(selector + " .sect-tl h3", { opacity: 0, y: 40, duration: 0.4, ease: 'power1.in' }) 
            .from(selector + " .container .planet-overlay", { opacity: 0, width:0, duration: 0.6, ease: 'power1.out'}, '-=0.2')  
              .from(selector + " .sp-txt .split-word", { opacity: 0, y:60, duration: 0.4, stagger: 0.1, ease: 'power1.out'}, '-=0.2')    
              .from(selector + " .plants-slider", { opacity: 0, y:40, duration: 0.6, ease: 'power1.out'}, '-=0.2')   
              .from(selector + " .plant-det", { opacity: 0, y:40, duration: 0.4, ease: 'power1.out'}, '-=0.2')  
              .from(selector + " .btn-hld", { opacity: 0, y:60, duration: 0.6, ease: 'power1.out' }, '-=0.2')  
          });

          animateSectionOnScroll('.bod-messages', function(tl, selector) { 
            tl.from(selector + " figure", { duration: 0.6, opacity: 0, scale: 0.6, } )
              .from(selector + " .svg-con", { duration: 0.4, opacity: 0, x:30 } , '-=0.2')
              .from(selector + " .anim-pan", { duration: 0.4, opacity: 0, y:50 } , '-=0.1')
             /*  .from(selector + " .sect-tl h3", { opacity: 0, y: 80, duration: 0.2, } , '-=0.2') */
              .from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, }, '-=0.2')
              .from(selector + " .lineChild", { duration: 0.4, opacity: 0, yPercent: 80, stagger: 0.1, }, '-=0.2') 
              /*.from(selector + " .bod-btns", { duration: 0.4, opacity: 0, y:30 }, '-=0.2')  */
              .from(selector + " .slide-nav", { duration: 0.4, opacity: 0, x: -50, }, '-=0.2')   
          })
  
          animateSectionOnScroll('.value-creation', function(tl, selector) {
            tl.from(selector + " .sect-tl h3", { opacity: 0, y: 40, duration: 0.4, ease: 'power1.in' })
              .from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, }, '-=0.2') 
              .from(selector + " .btn-hld", { duration: 0.4, opacity: 0, x: 30, }, '-=0.2')  
              .from(selector + " .value-details .nav-link", { duration: 0.4, opacity: 0, x: -50, stagger:0.1 }, '-=0.2')   
              .from(selector + " .tab-content", { duration: 0.4, opacity: 0, y: 50, }, '-=0.2')  
          });

          animateSectionOnScroll('#perfromance-chart', function(tl, selector) {
            tl.from(selector + " .sect-tl h3", { opacity: 0, y: 40, duration: 0.4, ease: 'power1.in' })
              .from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, }, '-=0.2')  
              .from(selector + " .nav-tabs .nav-item", { opacity: 0, y: 80, duration: 0.6, stagger: 0.1, }, '-=0.2') 
              .from(selector + " .tab-content", { duration: 0.4, opacity: 0, x: 100, }, '-=0.2')   
          });

          animateSectionOnScroll('.strategic-overview', function(tl, selector) { 
              tl.from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, })  
              .from(selector + " .lineChild", { duration: 0.4, opacity: 0, yPercent: 80, stagger: 0.1, }, '-=0.2') 
              .from(selector + " .btn-hld", { duration: 0.4, opacity: 0, y: 30, }, '-=0.2') 
              .from(selector + " .overview-card-blurb", { duration: 0.4, opacity: 0, y: 40, stagger:0.1 }, '-=0.2') 
          });

          animateSectionOnScroll('.sustainable-progress', function(tl, selector) { 
              tl.from(selector + " .sect-tl h3", { opacity: 0, y: 60, duration: 0.6, stagger: 0.1, })  
              tl.from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, }, '-=0.2')  
              .from(selector + " .lineChild", { duration: 0.4, opacity: 0, yPercent: 80, stagger: 0.1, }, '-=0.2') 
              .from(selector + " .btn-hld", { duration: 0.4, opacity: 0, x: 30, }, '-=0.2') 
              .from(selector + " .esg-blurb", { duration: 0.4, opacity: 0, y: 40, stagger:0.1 }, '-=0.2') 
          });

          animateSectionOnScroll('.matrix-hld', function(tl, selector) { 
              tl.from(selector + " .nav-link", { opacity: 0, x: 50, duration: 0.4, stagger: 0.1, })    
              .from(selector + " .matrix-info", { opacity: 0, x: -40, duration: 0.5, } , '-=0.2')   
              .from(selector + " .matrix-highlights", { opacity: 0, x: 40, duration: 0.5,  } , '-=0.2')   
              .from(selector + " .sp-txt .split-word",{ opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, }, '-=0.2')  
          });

          animateSectionOnScroll('.awards', function(tl, selector) { 
              tl.from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, } )  
              .from(selector + " .lineChild", { duration: 0.4, opacity: 0, yPercent: 80, stagger: 0.1, }, '-=0.2') 
              .from(selector + " .btn-hld", { duration: 0.4, opacity: 0, y: 30, }, '-=0.2') 
              .from(selector + " .award-blurb-con", { duration: 0.4, opacity: 0, x: 100, }, '-=0.2') 
          }); 

          animateSectionOnScroll('.case-study', function(tl, selector) { 
              tl.from(selector + " .sect-tl h3", { opacity: 0, y: 60, duration: 0.6 })  
                .from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, } , '-=0.2' )   
                .from(selector + " .cs-slider", { opacity: 0, y: 40,  duration: 0.4 } , '-=0.2' )   
          });

          animateSectionOnScroll('.download-center', function(tl, selector) {  
                tl.from(selector + " .sp-txt .split-word", { opacity: 0, y: 80, rotation:5, duration: 0.6, stagger: 0.1, } )   
                  .from(selector + " .report-panel", { opacity: 0, y: 50, duration: 0.4 } , '-=0.2' )   
                  .from(selector + " .circle-left", { opacity: 0, x: -30, duration: 0.4 } , '-=0.4' )   
                  .from(selector + " .circle-right", { opacity: 0, x: 30, duration: 0.4 } , '-=0.4' )   
          });
          
          
        });
      });
    }
  }
  
  // Fire after everything is loaded
  $(window).on('load', function () {
    setTimeout(() => {
      splashScreenAim();
      pageAnimation();
    }, 500);
  });
  
  
  
});